import React from 'react';
import { Link } from 'react-router-dom';

const SimpleHeader = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-opacity-95 backdrop-blur-sm" 
            style={{ backgroundColor: 'rgba(47, 47, 47, 0.95)' }}>
      <div className="container px-4 sm:px-6 lg:px-8">
        <nav className="flex items-center justify-between py-4" style={{ minHeight: '60px' }}>
          {/* Logo - Links back to home */}
          <Link to="/" className="flex items-center text-decoration-none">
            <img 
              src="/favicons/192x192.png" 
              alt="Logo Cercle Cadurcien d'Aïkido" 
              className="w-8 h-8 sm:w-10 sm:h-10 mr-2 sm:mr-3 flex-shrink-0"
            />
            <div className="flex flex-col justify-center leading-none">
              <h1 className="text-xs sm:text-sm lg:text-base font-bold text-primary uppercase tracking-wide"
                  style={{ color: 'var(--brand-primary)' }}>
                <span className="hidden sm:inline">Cercle Cadurcien</span>
                <span className="sm:hidden">CCA</span>
              </h1>
              <h2 className="text-xs sm:text-sm lg:text-base font-bold text-primary uppercase tracking-wide -mt-0.5"
                  style={{ color: 'var(--brand-primary)' }}>
                <span className="hidden sm:inline">d'Aïkido</span>
              </h2>
            </div>
          </Link>

          {/* Simple navigation - just home, teachers, FAQ, and contact */}
          <div className="flex items-center space-x-2 sm:space-x-4 flex-shrink-0">
            <Link 
              to="/"
              className="nav-link hidden sm:block"
            >
              Accueil
            </Link>
            <Link 
              to="/professeurs"
              className="nav-link text-xs sm:text-sm"
            >
              <span className="hidden sm:inline">Professeurs</span>
              <span className="sm:hidden">Prof</span>
            </Link>
            <Link 
              to="/faq"
              className="nav-link"
            >
              FAQ
            </Link>
            <Link 
              to="/#pricing"
              className="btn-primary text-xs sm:text-sm px-2 sm:px-4"
            >
              <span className="hidden sm:inline">Essai Gratuit</span>
              <span className="sm:hidden">Essai</span>
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default SimpleHeader;